import AuthLayout from '@/layouts/AuthLayout.vue'

export default [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/auth/LoginView.vue'),
    meta: {
      requiresAuth: false,
      layout: AuthLayout
    },
    alias: '/login'
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('@/views/auth/ResetPasswordView.vue'),
    meta: {
      requiresAuth: false,
      layout: AuthLayout
    }
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: () => import('@/views/auth/ForgotPasswordView.vue'),
    meta: {
      requiresAuth: false,
      layout: AuthLayout
    }
  },
  {
    path: '/confirmation-account',
    name: 'confirmationAccount',
    component: () => import('@/views/auth/ConfirmationAccountView.vue'),
    meta: {
      requiresAuth: false,
      layout: AuthLayout
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/auth/RegisterView.vue'),
    meta: {
      requiresAuth: false,
      layout: AuthLayout
    }
  }
]
